"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.component = exports.fragment = void 0;
const observable_1 = require("../reactivity/observable");
const unique_id_1 = require("../shared/unique-id");
const render_1 = require("./render");
const fragment = (...children) => {
    const base = document.createDocumentFragment();
    for (const child of children) {
        if (child instanceof Node) {
            base.appendChild(child);
        }
    }
    return base;
};
exports.fragment = fragment;
const onObservableChildren = (observable$, element) => {
    (0, render_1.render)(observable$, element);
};
const component = (tag, props) => {
    if (typeof tag === 'function') {
        return tag(props);
    }
    const element = typeof tag === 'string'
        ? (0, unique_id_1.attachElementId)(document.createElement(tag))
        : tag;
    if (!props) {
        return element;
    }
    const { children, ref, className, style, ...rest } = props;
    if (typeof ref === 'object') {
        ref.current = element;
        ref.effect?.(element);
    }
    if (typeof style === 'object') {
        Object.assign(element.style, style);
    }
    if (className) {
        if (element.classList.length > 0) {
            element.classList.value = '';
        }
        Array.isArray(className)
            ? element.classList.add(...className)
            : element.classList.add(className);
    }
    if (rest) {
        for (const [key, value] of Object.entries(rest)) {
            element.setAttribute(key, String(value));
        }
    }
    if (!children) {
        return element;
    }
    if (Array.isArray(children)) {
        for (const child of children) {
            if (typeof child === 'object') {
                if (child instanceof observable_1.Observable) {
                    onObservableChildren(child, element);
                }
                else {
                    if (child instanceof Promise) {
                        child.then((resolved) => element.appendChild(resolved));
                    }
                    else {
                        element.appendChild(child);
                    }
                }
            }
            else if (typeof child === 'string') {
                element.appendChild(document.createTextNode(child));
            }
        }
    }
    else if (typeof children === 'object') {
        if (children instanceof observable_1.Observable) {
            onObservableChildren(children, element);
        }
        else {
            if (children instanceof Promise) {
                children.then((resolved) => element.appendChild(resolved));
            }
            else {
                element.appendChild(children);
            }
        }
    }
    else {
        element.innerHTML = String(children);
    }
    return element;
};
exports.component = component;
//# sourceMappingURL=data:application/json;base64,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